import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type NamirialSettingsSpecFragment = (
  { __typename: 'NamirialSetting' }
  & Pick<SchemaTypes.NamirialSetting, 'id' | 'namirialModuleId' | 'endpoint'>
);

export const NamirialSettingsSpecFragmentDoc = /*#__PURE__*/ gql`
    fragment NamirialSettingsSpec on NamirialSetting {
  id
  namirialModuleId
  endpoint
}
    `;